import React from "react";

import {METRICS} from "../../../../utils/constants";
import {OptionButton} from "../../../../designSystem/components/OptionButton";

type MetricSelectorProps = {
  selectedMetric: string;
  onPressMetric: (metricKey: string) => void;
};

export const MetricSelector = ({selectedMetric, onPressMetric}: MetricSelectorProps) => (
  <div className="flex flex-row gap-2 overflow-x-auto flex-nowrap pb-4 px-2">
    {METRICS.map((metric) => (
      <OptionButton
        key={metric.key}
        label={metric.label}
        isSelected={selectedMetric === metric.key}
        onClick={() => onPressMetric(metric.key)}
        icon={metric.icon}
      />
    ))}
  </div>
);
